import { Box, Card, Divider, Icon, IconButton, Modal, ModalProps, Typography } from "@mui/material";
import { HidroLayerGroup, HidroLayersComponent } from "./layers";
import { HidroMap } from "./mapa";

interface Props extends ModalProps {
  layergroup?: HidroLayerGroup;
  onFinish?: (layers: HidroLayerGroup | undefined) => void;
}

export const ExpandModal: React.FC<Props> = (props) => {
  const { onFinish, layergroup, ...dialogProps } = props;

  const handleClose = () => {
    if (onFinish) {
      onFinish(layergroup?.copy());
    }
  };

  return <Modal
    {...dialogProps}
    onClose={handleClose}
  >
    <Card sx={{
      width: "95vw",
      height: "95vh",
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      display: "flex",
      flexDirection: "column",
      p: "5px",
    }}>
      {/* Título */}
      <div style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        height: "46px",
        padding: "10px",
      }}>
        <Typography fontWeight={"bold"} fontSize={22}>{layergroup?.name ?? "Mapa Expandido"}</Typography>
        <div style={{ flex: 1 }} />
        <IconButton onClick={handleClose}>
          <Icon>close</Icon>
        </IconButton>
      </div>

      <Divider />
      <div style={{ height: "5px" }} />

      <div style={{ flex: 1, display: "flex", flexDirection: "row" }}>

        {/* Mapa */}
        <Box sx={{
          width: "100%",
          height: "100%",
        }}>
          <HidroMap
            screenshot
            chooseMap
            recenter
            animateStart={false}
            showTooltips
            hidroLayers={layergroup}
          />
        </Box>

        {/* Layers */}
        {layergroup && <Box sx={{ width: "15vw" }}>
          <HidroLayersComponent
            hidroLayers={layergroup}
            maxWidth={"15vw"}
          />
        </Box>}
      </div>
    </Card>
  </Modal>;
};